import { useCallback, useState } from 'react';
import type { FC } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

export interface FloatingCoin {
  id: string;
  value: number;
  x: number;
  y: number;
}

interface FloatingCoinsProps {
  clicks: FloatingCoin[];
}

export const FloatingCoins: FC<FloatingCoinsProps> = ({ clicks }) => {
  return (
    <AnimatePresence>
      {clicks.map((click) => (
        <motion.div
          key={click.id}
          initial={{ opacity: 1, scale: 0.6, x: click.x, y: click.y }}
          animate={{ opacity: 0, scale: 1.6, y: click.y - 100 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.2, ease: 'easeOut' }}
          className="pointer-events-none absolute text-2xl font-extrabold text-yellow-300"
          style={{
            textShadow: '0 0 12px rgba(253, 224, 71, 0.8)',
            filter: 'drop-shadow(0 3px 6px rgba(0,0,0,0.35))'
          }}
        >
          +{click.value} 🪙
        </motion.div>
      ))}
    </AnimatePresence>
  );
};

export const useFloatingCoins = () => {
  const [clicks, setClicks] = useState<FloatingCoin[]>([]);

  const addFloatingCoin = useCallback((value: number, x: number, y: number) => {
    const id = `${Date.now()}-${Math.random()}`;
    const coin: FloatingCoin = { id, value, x, y };

    setClicks((prev) => [...prev, coin]);

    window.setTimeout(() => {
      setClicks((prev) => prev.filter((item) => item.id !== id));
    }, 1200);
  }, []);

  return { clicks, addFloatingCoin };
};
